module.exports = __webpack_public_path__ + "img/sezione_mobilita_sicura.74765fde.jpg";